import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/PanelRenderer.tsx";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@mui/material';
import { Layers } from '@mui/icons-material';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { formatDateTime } from "../../Migration/UpdateDialog";
import { DefaultPanelRender } from "../../ImportEstimation/components/DefaultPanelRender";
import { AddDepButton } from "./AddDepButton";
import { VersionButton } from "./VersionButton/VersionButton";
import { useModelProps } from "./itemPropsCtx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PanelRenderer = /*#__PURE__*/React.memo(function (props) {
  var _props$item$payload;

  switch ((_props$item$payload = props.item.payload) === null || _props$item$payload === void 0 ? void 0 : _props$item$payload.type) {
    case 'BimFileTreeNode':
      return /*#__PURE__*/_jsx(BimFileChildrenPanel, _objectSpread({}, props));

    default:
      return /*#__PURE__*/_jsx(DefaultPanelRender, _objectSpread({}, props));
  }
});
PanelRenderer.displayName = 'PanelRenderer'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var emptyArr = [];
var BimFileChildrenPanel = /*#__PURE__*/React.memo(function (_ref) {
  var item = _ref.item;
  var bimFile = item.payload;

  var _useModelProps = useModelProps(bimFile),
      isAdded = _useModelProps.isAdded,
      currentEntityData = _useModelProps.currentEntityData,
      included = _useModelProps.included,
      seoEventHandler = _useModelProps.seoEventHandler;

  var children = item.children || // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emptyArr;
  return /*#__PURE__*/_jsx(List, {
    children: children === null || children === void 0 ? void 0 : children.map(function (it) {
      var _it$payload = it.payload,
          versionName = _it$payload.versionName,
          uploadDate = _it$payload.uploadDate,
          author = _it$payload.author,
          status = _it$payload.status,
          isCurrent = _it$payload.isCurrent;
      return /*#__PURE__*/_jsxs(ListItem, {
        button: true,
        dense: true,
        disabled: isAdded && !isCurrent,
        children: [/*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Layers, {})
        }), /*#__PURE__*/_jsxs(ListItemText, {
          disableTypography: true,
          children: [/*#__PURE__*/_jsxs(Typography, {
            variant: "body2",
            children: ["v", versionName, ' ', /*#__PURE__*/_jsxs(Typography, {
              component: "span",
              variant: "caption",
              color: "textSecondary",
              children: ["(", formatDateTime(uploadDate), ")"]
            })]
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "caption",
            color: "textSecondary",
            children: author
          }), /*#__PURE__*/_jsxs(ListItemSecondaryAction, {
            children: [currentEntityData && /*#__PURE__*/_jsx(AddDepButton, {
              bimFile: bimFile,
              currentEntity: currentEntityData,
              elementsIncluded: included,
              isAdded: isAdded,
              disabled: isAdded && !isCurrent,
              dataTestId: isAdded ? 'RemoveVersionFromDependency' : 'addVersionToDependency',
              seoEventHandler: seoEventHandler
            }), /*#__PURE__*/_jsx(VersionButton, {
              versionName: versionName,
              status: status,
              author: author,
              uploadDate: uploadDate
            })]
          })]
        })]
      }, it.key);
    })
  });
});
BimFileChildrenPanel.displayName = 'BimFileChildrenPanel';